var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"inline-flex m-0 ml-5",attrs:{"color":"success"}},[_vm._v("\n  Coming Soon\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }